import propTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logout } from '../../actions/auth';
import logo from '../../images/logo.svg';


const Navbar = ({ auth: { user, isAuthenticated, loading}, logout }) => {
  return (
    <nav className="navbar">

      <div className="row" style={{ width: "100%"}}>

        <div className="col navbar-inner-first">
          <ul>
            <li style={{ "maxHeight": "30px"}}><Link to='/'><img src = {logo} alt='logo' style={{ "maxHeight": "40px", "marginTop":"25px"}}/></Link></li>
            <li style={{ "maxHeight": "30px"}}><Link to='/'><h2 style={{color: 'white'}}> &nbsp; GharBar</h2></Link></li>
          </ul>
        </div>

        <div className="col navbar-inner-first">
          <ul style={{ "marginTop": "30px", "justifyContent": "right"}}>
            <li> { !isAuthenticated && <Link to='/guestLogin'> <i className='fa fa-circle-user'/> Login</Link> } </li>
            <li> { !isAuthenticated && <Link to='/adminLogin'> <i className='fa fa-key'/> Staff</Link> }</li>
            <li>
              { isAuthenticated && user && user.usertype === 'admin' &&
                (
                  <>
                      <Link to='/adminDashboard'> <i className='fa fa-grid-horizontal'/> Dashboard</Link>
                  </>
                )
              }
              { isAuthenticated && user && user.usertype === 'guest' &&
                (
                  <>
                      <Link to='/bookings'> <i className='fa fa-receipt'/> Bookings</Link>
                  </>
                )
              }
              {
                isAuthenticated && (
                  <>
                    <a onClick={logout} href='#!'>
                      <i className='fa-solid fa-right-from-bracket'></i>{' '}
                      <span className='hide-sm'>Logout</span>
                    </a>
                  </>
                )
              }
            </li>
          </ul>
        </div>
        
      </div>

      <div className="navbar-inner-second">
        <ul>
          <li><Link to='/rooms'> <i className="fa fa-bed" /> Rooms</Link></li>
          <li><Link to='/bar'> <i className="fa fa-wine-glass-empty" /> Bar</Link></li>
          <li><Link to='/conference'> <i className="fa fa-microphone" /> Conference Hall</Link></li>
          <li><Link to='/banquet'> <i className="fa fa-ring" /> Banquet Hall</Link></li>
          <li><Link to='/promotions'> <i className="fa fa-tag" /> Promotions</Link></li>
          <li><Link to='/gallery'> <i className="fa fa-images" /> Gallery</Link></li>
        </ul>
      </div>

    </nav>
  )
};

Navbar.propTypes = {
  logout: propTypes.func.isRequired,
  auth: propTypes.object.isRequired
}

const mapStateToProps = state => ({
  auth: state.auth
})

export default connect(mapStateToProps, { logout })(Navbar);
